export const SUPPORTED_EXT =
  'aac,ai,aiff,asp,avi,blank,bmp,c,cpp,css,dat,dmg,doc,' +
  'docx,dot,dotx,dwg,dxf,eps,exe,flv,gif,h,html,ics,iso,' +
  'java,jpg,key,m4v,mid,mov,mp3,mp4,mpg,odp,ods,odt,otp,' +
  'ots,ott,pdf,php,png,pps,ppt,psd,py,qt,rar,rb,rtf,sql,' +
  'tga,tgz,tiff,txt,wav,xls,xlsx,xml,yml,zip'.split(',')
